import { render, staticRenderFns } from "./SyncDNSDialog.vue?vue&type=template&id=1f6668fe&"
import script from "./SyncDNSDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncDNSDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports